import ApiBase, { baseUrl } from '.';

export default class MediaApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/Media`, token);
  }

  uploadImage(file) {
    let formData = new FormData();
    formData.append('File', file);
    return this.authHttp.post(`${this.baseUrl}/UploadImage`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  uploadPptx(file) {
    let formData = new FormData();
    formData.append('File', file);
    return this.authHttp.post(`${this.baseUrl}/UploadPptx`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  uploadFile(file) {
    let formData = new FormData();
    formData.append('File', file);
    return this.authHttp.post(`${this.baseUrl}/UploadFile`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  get(uri) {
    return this.authHttp.get(`${this.baseUrl}/Get`, { params: { uri: uri } });
  }
}
